'use strict'

import WaveIndex from '@/pages/Wave/WaveList.vue'
import Wave from '@/pages/Wave/Wave.vue'
import WaveStats from '@/pages/Wave/WaveStats.vue'
import ifAuthenticated from '@/router/middleware'

export default [
  {
    path: '/:site/waves',
    name: 'Waves',
    component: WaveIndex,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: '/:site/waves/:id',
    name: 'Wave',
    component: Wave,
    beforeEnter: ifAuthenticated,
    props: true
  },
  {
    path: '/:site/waves/:id/stats',
    name: 'WaveStats',
    component: WaveStats,
    beforeEnter: ifAuthenticated,
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/router/domains/wave.js